import config from '@/config'

export default {
  combine: {
    confirm_password: "Confirm @:ui.password",
    change_password: "Change @:ui.password",
    old_password: "Old @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "Confirm @:ui.security_code",
    first_time_login: "First Time Login",
    security_authentication: "Security Authentication",
    update_security: "Update Security",
    disable_security: "Disable Security",
    add_account: "Add Account",
    add_sub_account: "Add Sub Account",
    edit_operator: "Edit Operator",
    edit_account: "Edit Account",
    edit_member: "Edit Member",
    approve_ticket: "Approve Ticket",
    reject_ticket: "Reject Ticket",
    add_bank_account: "Add Bank Account",
    edit_bank_account: "Edit Bank Account",
    reset_threshold: "Reset Threshold",
    adjust_balance: "Adjust Balance",
    adjust_member: "Adjust Member",
    configure_bank_setting: "Configure Bank Setting",
    account_setup: "Account Setup",
    bank_transfer: "Bank Transfer",
    edit_bank_member: "Edit Bank Member",
    edit_ticket: "Edit Ticket",
    edit_vip: "Edit VIP",
    knock_off_promo: "Knock Off Promotion",
    edit_authority: "Edit Authority",
    reset_password: "Reset Password",
    update_password: "Update Password",
    member_summary: "Member Summary",
    reply_review: "Reply Review",
    edit_affiliate: "Edit Affiliate",
    edit_bank_affiliate: "Edit Bank Affiliate",
    approve_affiliate_ticket: "Approve Affiliate Ticket",
    check_free_spin: "Check Free Spin",
    reject_affiliate_ticket: "Reject Affiliate Ticket",
    wallet_adjust: "Wallet Adjust",
    update_comm_package: "Update Comm Package",
    approve_affiliate: "Approve Affiliate",
    sub_acc_detail_affiliate: "Sub Account Detail Affiliate",
    get_tac: "Get OTP",
    add_coupon: "Add Coupon",
    update_coupon: "Update Coupon",
    issue_free_spin: "Issue Free Spin",
    get_bank_tac: "Get Bank OTP",
    update_global_setting: "Update Global Setting",
    add_platform: "Add Platform",
    edit_platform: "Edit Platform",
    add_bank_group: "Add Bank Group",
    edit_bank_group: "Edit Bank Group",
    update_maintenance_schedule: "Update Maintenance Schedule",
    add_withdrawal_limit: "Add Withdrawal Limit",
    edit_withdrawal_limit: "Edit Withdrawal Limit",
    add_campaign: "Add Campaign",
    edit_campaign: "Edit Campaign",
    add_promo_group: "Add Promotion Group",
    edit_promo_group: "Edit Promotion Group",
    update_team: "Update Team",
    update_result: "Update Result",
    insert_result: "Insert Result",
    bet_list: "Bet List",
    result_list: "Result List",
    add_promo: "Add Promotion",
    raise_deposit_ticket: "Raise Deposit Ticket",
    bank_adjust: "Bank Adjust",
    promo_member_assign: "Promotion Member Assign",
    bonus_issue: "Bonus Issue",
    update_vip: "Update VIP",
    update_member_profile: "Update Member Profile",
    change_withdrawal_limit: "Change Withdrawal Limit",
    change_bank_group: "Change Bank Group",
    change_promotion_group: "Change Promotion Group",
    edit_promo_signup: "Edit Promotion Signup",
    update_provider_bet_limit: "Update Provider Bet Limit",
    update_bet_limit: "Update Bet Limit",
    update_member_bet_limit: "Update Member Bet Limit",
    edit_bank_account_group: "Edit Bank Account Group",
    redeposit_ticket: "Redeposit Ticket",
    edit_promotion_group: "Edit Promotion Group",
    edit_promotion_group_norm: "Manage Promotion In Group",
    get_inbox_list: "Get Inbox List",
    view_result_changes_detail: "View Result Changes Detail",
    edit_promotion_signup: "Edit Promotion Signup",
    edit_bet_limit: "Edit Bet Limit",
    edit_provider_game_off: "Edit Provider Game Off",
    edit_provider_rtp: "Edit Provider RTP",
    get_rebate: "Get Rebate",
    get_recent_deposit: "Get Recent Deposit",
    add_survey: "Add Survey",
    add_announcement_banner: "Add Announcement Banner",
    edit_announcement_banner: "Edit Announcement Banner",
    move_announcement_banner: "Move Announcement Banner",
    add_promotion_banner: "Add Promotion Banner",
    edit_promotion_banner: "Edit Promotion Banner",
    unlink_banner: "Unlink",
    move_promotion_banner: "Move Promotion Banner",
    add_slide_banner: "Add Slide Banner",
    edit_slide_banner: "Edit Slide Banner",
    move_slide_banner: "Move Slide Banner",
    add_seo_page: "Add SEO Page",
    edit_seo_page: "Edit SEO Page",
    clear_outstanding: "Clear Outstanding",
    add_ip_whitelist: "Add IP Whitelist",
    bonus_issue_bulk: "Bulk Bonus Issue",
    edit_bank_member_ewallet: "Edit Bank Member (E-Wallet)",
    redeposit: "Redeposit",
    reject_approved_ticket: "Reject Approved Ticket",
    audit_ticket: "Audit Ticket",
    review_ticket: "Review Ticket",
    edit_promotion_group_norm_seq: "Manage Promotion Sequence In Group",
    edit_promo_provider_list: "Edit Promotion Provider List",
    edit_promo_payment_option: "Edit Promotion Payment Option",
    edit_campaign_provider_list: "Edit Campaign Provider List",
    update_comm: "Update Commission",
    update_carry_over: "Update Carry Over",
    review_affiliate_ticket: "Review Affiliate Ticket",
    audit_affiliate_ticket: "Audit Affiliate Ticket",
    get_tac_affiliate: "Get OTP (Affiliate)",
    raise_deposit_ticket_gateway: "Raise Deposit Ticket (Gateway)",
    direct_audit_ticket: "Audit Ticket (Direct)",
    get_rollback_detail: "Get Rollback Detail",
    get_reject_detail: "Get Reject Detail",
    manual_approve_ticket: "Approve Ticket (Manual)",
    add_label: "Add Label",
    edit_label: "Edit Label",
    rollback_processing_ticket: "Rollback Processing Ticket",
    update_iframe_url: "Update Iframe URL",
    edit_exchange_rate: "Edit Exchange Rate",
    add_vip: "Add VIP",
    add_turnover_tier: "Add Turnover Tier",
    edit_turnover_tier: "Edit Turnover Tier",
    edit_mission_reward: "Edit mission reward",
    enable_mission_reward: "Enable mission reward",
    get_member_label_list: "Member Label List",
    add_rescue_fund: "Add Rescue Fund",
    get_custom_member_list: "Custom Member List",
    get_rescue_fund_provider: "Get Rescue Fund Provider",
    add_game_exclude: "Add Game Exclude",
    delete_game_exclude: "Delete Game Exclude",
    domain_custom_add_assign: "Add Domain",
    add_domain_batch: "Add Domain (Batch)",
    update_payment_provider_vip: "Update Payment Provider Vip",
    update_campaign: "Update Campaign",
    purchase_domain: "Purchase Domain",
    apply_domain: "Apply Domain",
    edit_access_control: "Edit Access Control",
    add_domain: "Add domain",
    operator_wallet_adjust: "Adjust Operator Wallet",
    update_payment_provider_desc: "Update Payment Provider Description",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Setup Logo",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "Provider PT Operator Update",
    provider_pt_global_update: "Provider PT Global Update",
    payment_option_callback_update: "Callback URL Update",
    change_payment_option_seq: "Payment Option Sequence",
    change_payment_mode_status: "Payment Option Status Update",
    change_payment_option_recommend: "Payment Option Recommend",
    change_payment_option_credential: "Payment Option Credential",
    change_payment_option_limit: "Payment Option Limit",
    change_payment_option_vip: "Payment Option VIP",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
    add_leaderboard: "@:ui.add @:ui.leaderboard",
    edit_leaderboard: "@:ui.edit @:ui.leaderboard",
    add_phone: "@:ui.add @:ui.phone",
    adjust_free_balance: "Adjust Free Balance",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "Payment Option Description",
    fund_transfer_provider: "Fund Transfer Provider",
    manual_deposit: "Manual Deposit",
    change_linkage_desc: "Linkage Description",
    change_linkage_risk_weight: "Linkage Risk Weight",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "Get Voucher Custom Member List",
    redeposit_ticket_voucher: "Redeposit Ticket Voucher",
    approve_ticket_voucher: "Approve Ticket Voucher",
    reject_ticket_voucher: "Reject Ticket Voucher",
    raise_deposit_ticket_voucher: "Raise Deposit Ticket Voucher",
    raise_deposit_ticket_voucher_gateway: "Raise Deposit Ticket Voucher Gateway",
    get_voucher_list: "Get Voucher List",
    get_message_list: "Get Message List",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "Knock Off Free Credit Member",
    free_credit_manual_assign: "Free Credit Manual Assign",
    review_fcp_ticket: "Review Free Credit Provider Ticket",
    audit_fcp_ticket: "Audit Free Credit Provider Ticket",
    reject_fcp_ticket: "Reject Free Credit Provider Ticket",
    approve_fcp_ticket: "Approve Free Credit Provider Ticket",
    edit_trigger: "Edit Trigger",
    edit_trigger_status: "Edit Trigger Status",
    adjust_voucher_balance: "Adjust Voucher Balance",
    clear_free_credit: "Clear Free Credit",
    add_deposit_tier: "Add Deposit Tier",
    edit_deposit_tier: "Edit Deposit Tier",
    add_leaderboard_banner: "Add Leaderboard Banner",
    edit_leaderboard_banner: "Edit Leaderboard Banner",
    add_referral_banner: "Add Referral Banner",
    edit_referral_banner: "Edit Referral Banner",
    edit_vip_icon: "Edit VIP Icon",
    add_reward_rain: "Add Reward Rain",
    edit_reward_rain: "Edit Reward Rain",
    add_reward_rain_session: "Add Reward Rain Session",
    edit_reward_rain_session: "Edit Reward Rain Session",
    edit_reward_rain_session_end_date: "Edit Reward Rain Session End Date",
    add_news: "Add News",
    edit_news: "Edit News",
  },
  short: {
    deposit_amount: "Dep Amt",
    base_amount: "Base Amt",
    bonus_amount: "Bonus Amt",
    target_amount: "Trgt Amt",
    knockoff_by: "K.O By",
    knockoff_date: "K.O Date",
    incoming_threshold: "IN THRES",
    incoming_frequency: "IN FREQ",
    outgoing_threshold: "OUT THRES",
    outgoing_frequency: "OUT FREQ",
    account_balance: "ACC BAL",
    claim_type: "C.Type",
    bonus_rate: "B.Rate",
    max_bonus: "M.Bonus",
    rollover: "Rollover",
    criteria: "Criteria",
    start_time: "S.Time",
    end_time: "E.Time",
    monday: "MON",
    tuesday: "TUE",
    wednesday: "WED",
    thursday: "THU",
    friday: "FRI",
    saturday: "SAT",
    sunday: "SUN",
    status: "Status",
    bonus_rate_percent: "B.Rate (%)",
    valid_turnover: "V.Turnover",
    deposit_count: "Dep Cnt",
    withdrawal_amount: "Wdw Amt",
    withdrawal_count: "Wdw Cnt",
    adjustment_amount: "Adj Amt",
    referee_count: "Referee Cnt",
    signup_count: "Signup Cnt",
    verified_count: "VRF Count",
    active_member: "Active Mbm",
    ftd_count: "FTD Cnt",
    ftd_amount: "FTD Amt",
    working_date: "Working DT",
    recipient_bank_id: "R.Bank ID",
    recipient_bank_acc_no: "R.Bank Acc No.",
    recipient_bank_acc_holder: "R.Bank Acc Holder",
    sender_bank: "S.Bank",
    sender_bank_acc_no: "S.Bank Acc No.",
    sender_bank_acc_holder: "S.Bank Acc Holder",
    unique_login_count: "U.Login Cnt",
    unique_deposit_count: "U.Dep Cnt",
    unique_withdrawal_count: "U.Wdw Cnt",
    second_deposit_count: "S.Dep Cnt",
    reject_date: "R.Date",
    processing_date: "P.Date",
    deposit_withdrawal_different: "Dep Wdw Diff",
    external_id: "Ex. ID",
    draft_version: "Draft. Ver.",
    prod_version: "Prod. Ver.",
    purchased_date: "P. Date",
    completed_amount: "Compl Amt",
    min_amount: "Min. Amt",
    max_amount: "Max. Amt",
    total_claimed_amount: "Total Claimed Amt"
  },
  date_ranges: {
    0: "Today",
    1: "Yesterday",
    2: "This Month",
    4: "Last Month",
  },
  langList: {
    EN: "English",
    CN: "Chinese",
    PHP: "Philippines",
    esp: "Español",
    RUS: "Russian",
    VI: "Vietnamese",
    MS: "Malay",
    NE: "Nepalese",
    CT: "Chinese-TW",
    BN: "Bangla"
  },
  menulist: {
    home: "Home",
    hot: "Hot",
    slot_game: "Slot",
    casino: "Casino",
    sportsbook: "Sports",
    fishing: "Fishing",
    lottery: "Lottery",
    poker: "Poker",
    hash_game: "Hash Game",
    sabong: "Sabong",
    promotion: "Promotion",
    review: "Review",
    news: "News",
    live_stream: "Live Stream",
    vip: "VIP",
    referral: "Referral",
    favourite: "Favourite",
    mission: "Mission (Mini Game)",
    spin: "Spin",
    leaderboard: "Leaderboard",
    account: "Account",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    bet_history: "Bet History",
    pending_status: "Pending Status",
    change_password: "Change Password",
    profile: "Profile",
    banking_details: "Banking Details",
    inbox: "Inbox",
    voucher: "Voucher",
    wallet: "Wallet",
    statement: "Statement",
    download: "Download",
    game: "Game",
    special: "Special",
    misc: "Misc",
    contact_us: "Contact Us",
    e_sportsbook: "E-Sportsbook",
    lotto: "Lotto",
    p2p: "P2P",
    other: "Other",
    vip2: "VIP2",
    referral2: "Referral2",
    event: "Event",
    daily_reward: "Daily Reward",
    play2earn: "Play 2 Earn",
    redemption: "Redemption",
    card_board: "Card Board",
    lobby: "Lobby",
    in_house: "In House",
    transfer: "Transfer",
    horse_racing: "Horse Racing",
    register: "Register",
    login: "Login",
    transaction_history: "Transaction History",
    bingo: "Bingo",
    member: "Member",
    arcade: "Arcade",
    crash: "Crash",
    freeplay: "Free Play",
    others: "Others",
  },

  ok: "OK",
  cancel: "Cancel",
  login: "Login",
  logout: "Logout",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  refresh: "Refresh",
  action: "Action",
  id: "ID",
  name: "Name",
  all: "All",
  search: "Search",
  remove: "Remove",
  save: "Save",
  account: "Account",
  settings: "Settings",
  on: "ON",
  off: "OFF",
  new: "New",
  clear: "Clear",
  users: "User | Users",
  username: "Username",
  password: "Password",
  created_on: "Create On",
  active: "Active",
  page_size: "Page Size",
  status: "Status",
  result: "Result",
  close: "Close",
  back: "Back",
  show: "Show",
  login_id: "Login ID",
  date_time: "DateTime",
  ip_address: "Ip Address",
  domain_name: "Domain Name",
  browser_agent: "Browser Agent",
  action_by: "Action By",
  details: "Details",
  key: "Key | Keys",
  value: "Value | Values",
  from: "From",
  to: "To",
  type: "Type",
  criteria: "Criteria",
  log: "Log",
  report: "Report",
  security_tag: "Security Tag",
  security_code: "Security Code",
  submit: "Submit",
  disable: "Disable",
  operators: "Operator | Operators",
  members: "Members",
  account_id: "Account ID",
  confirm_password: "Confirm Password",
  full_name: "Full Name",
  contact_phone: "Contact Phone",
  contact_email: "Contact Email",
  dashboard: "Dashboard",
  sub_account: "Sub Account",
  authority_option: "Authority Option",
  banks: "Bank | Banks",
  login_ip : "Login Ip",
  block: "Block",
  profile_id: "Profile ID",
  suspend: "Suspend",
  deposit: "Deposit",
  withdrawal: "Withdrawal",
  bulk_withdrawal: "Bulk Withdrawal",
  rejected: "Rejected",
  processed: "Processed",
  pending: "Pending",
  member: "Member",
  amount: "Amount",
  bank_acc_no: "Bank Acc No.",
  deposit_date: "Deposit Date",
  deposit_method: "Deposit Method",
  approve: "Approve",
  reject: "Reject",
  remark: "Remark",
  ticket_detail: "Ticket Detail",
  promo: "Promo",
  package: "Package",
  created_date: "Created Date",
  currency: "Currency",
  bank_acc_holder: "Bank Acc Holder",
  ref_no: "Ref No.",
  vip: "VIP",
  modified_date: "Modified Date",
  modified_by: "Modified By",
  bank_member: "Bank Member",
  bank_operator: "Bank Operator",
  bank_name: "Bank Name",
  bank_acc_type: "Bank Acc Type",
  account_balance: "Account Balance",
  threshold: "Threshold",
  incoming: "Incoming",
  outgoing: "Outgoing",
  frequency: "Frequency",
  reset_threshold: "Reset Threshold",
  adjust_balance: "Adjust Balance",
  bank_from: "Bank From",
  bank_to: "Bank To",
  attachment: "Attachment",
  sender_bank: "Sender Bank",
  sender_bank_acc_no: "Sender Bank Acc No.",
  sender_bank_acc_holder: "Sender Bank Acc Holder",
  audit: "Audit",
  action_status: "Action Status",
  action_date: "Action Date",
  promotion: "Promotion",
  promo_id: "Promo ID",
  promo_name: "Promo Name",
  package_id: "Package ID",
  claim_type: "Claim Type",
  bonus_rate: "Bonus Rate",
  max_bonus: "Max Bonus",
  rollover: "Rollover",
  start_date: "Start Date",
  end_date: "End Date",
  adj_amount: "Adjust Amount",
  promotion_member: "Promotion Member",
  on_going: "On Going",
  knock_off: "Knock Off",
  all_ongoing: "All Ongoing",
  deposit_amount: "Deposit Amount",
  base_amount: "Base Amount",
  bonus_amount: "Bonus Amount",
  target_amount: "Target Amount",
  claim_date: "Claim Date",
  accumulate_win: "Accumulate Win",
  accumulate_turnover: "Accumulate Turnover",
  bonus: "Bonus",
  bonus_log: "Bonus Log",
  member_id: "Member ID",
  before_balance: "Before Balance",
  transfer_amount: "Transfer Amount",
  after_balance: "After Balance",
  created_by: "Created By",
  bonus_name: "Bonus Name",
  bonus_desc: "Bonus Description",
  bonus_type: "Bonus Type",
  add_promo: "Add Promotion",
  bonus_value: "Bonus Value",
  attach_promo: "Attach Promotion",
  daily_statement: "Daily Statement",
  working_date: "Working Date",
  opening_balance: "Opening Balance",
  turnover: "Turnover",
  valid_turnover: "Valid Turnover",
  winlose: "WinLose",
  withdrawal_amount: "Withdrawal Amount",
  closing_balance: "Closing Balance",
  sub_total: "Sub Total",
  grand_total: "Grand Total",
  daily_winlose: "Daily Winlose",
  game_result_slots: "Game Result (Slots)",
  game_result_livecasino: "Game Result (Livecasino)",
  game_result_rebate: "Game Result (Rebate)",
  game_result_sportsbook: "Game Result (Sportsbook)",
  game_result_cockfight: "Game Result (Cockfight)",
  game_result_rescue: "Game Result (Rescue)",
  game_result_others: "Game Result (Others)",
  bet_count: "Bet Count",
  result_id: "Result ID",
  bet_time: "Bet Time",
  result_time: "Result Time",
  payout: "Payout",
  game_type: "Game Type",
  game_name: "Game Name",
  game_provider: "Game Provider",
  reset: "Reset",
  mode: "Mode",
  balance: "Balance",
  min_bal_knock_off_promo: "Min Bal. (To auto knock off promotion)",
  social_account: "Social Account",
  wechat: "Wechat",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  login_log: "Login Log",
  platform: "Platform",
  bank_statement: "Bank Statement",
  transfer_date: "Transfer Date",
  detail: "Detail",
  date: "Date",
  transfer_list: "Transfer List",
  credit: "Credit",
  badge: "Badge",
  debit: "Debit",
  month: "Month",
  unblock: "Unblock",
  unblock_member: "Unblock Member",
  unblock_operator: "Unblock Operator",
  referrer_id: "Referrer ID",
  referrer_code: "Referrer Code",
  referral_code: "Referral Code",
  bonus_and_adjustment: "Bonus & Adjustment",
  adjustment: "Adjustment",
  incoming_amount_threshold: "Incoming Amount Threshold",
  outgoing_amount_threshold: "Outgoing Amount Threshold",
  knock_off_by: "Knock Off By",
  knock_off_date: "Knock Off Date",
  total_turnover: "Total Turnover",
  total_winlose: "Total Winlose",
  total_deposit: "Total Deposit",
  total_member: "Total Member",
  active_player: "Active Player",
  top_winner: "Top Winner",
  top_loser: "Top Loser",
  winner: "Winner",
  loser: "Loser",
  deposit_count: "Deposit Count",
  withdrawal_count: "Withdrawal Count",
  alert: "Alert",
  incoming_threshold: "Incoming Threshold",
  incoming_frequency: "Incoming Frequency",
  outgoing_threshold: "Outgoing Threshold",
  outgoing_frequency: "Outgoing Frequency",
  reset_password: "Reset Password",
  transfer: "Transfer",
  company_bank: "Company Bank",
  company_bank_acc_no: "Company Bank Acc No.",
  company_bank_acc_holder: "Company Bank Acc Holder",
  registered_member: "Registered Member",
  promotion_report: "Promotion Report",
  deposited_member: "Deposited Member",
  referred_member: "Referred Member",
  validated_on: "Validated On",
  first_deposit: "First Deposit",
  reward: "Reward",
  inbox: "Inbox",
  manual_bonus: "Manual Bonus",
  review: "Review | Reviews",
  reviews: "Reviews",
  review_list: "Review List",
  review_detail: "Review Detail",
  reply_review: "Reply Review",
  comment: "Comment",
  reply: "Reply",
  recipient_no: "Recipient No.",
  question : "Question",
  rating: "Rating",
  content: "Content",
  image: "Image",
  monthly_rating: "Monthly Rating",
  affiliate: "Affiliate",
  affiliate_list: "Affiliate List",
  affiliate_code: "Affiliate Code",
  approved_by: "Approved By",
  approved_date: "Approved Date",
  bank_affiliate: "Bank Affiliate",
  bank_id: "Bank ID",
  ticket_detail_affiliate: "Ticket Detail Affiliate",
  pending_application: "Pending Application",
  pending_review_withdrawal: "Pending & Review Withdrawal",
  unblock_affiliate: "Unblock Affiliate",
  wallet_adjust: "Wallet Adjust",
  comm_package: "Comm Package",
  affiliate_id: "Affiliate ID",
  sub_account_detail: "Sub Account Detail",
  daily_winlose_affiliate: "Daily Winlose (Affiliate)",
  daily_deposit_affiliate: "Daily Deposit (Affiliate)",
  export_excel: "Export Excel",
  get_tac: "Get OTP",
  tac_code: "OTP Code",
  expiry_date: "Expiry Date",
  inactive: "Inactive",
  last_deposit_date: "Last Deposit Date",
  coupon: "Coupon",
  allocated: "Allocated",
  claimed: "Claimed",
  approved: "Approved",
  coupon_code: "Coupon Code",
  coupon_quota: "Coupon Quota",
  current_allocated: "Current Allocated",
  new_allocated: "New Allocated",
  update : "Update",
  copy: "Copy",
  bonus_rate_percent : "Bonus Rate (%)",
  coupon_desc: "Coupon Description",
  both: "Both",
  issue_free_spin: "Issue Free Spin",
  game: "Game",
  max_win_amount: "Max Win Amount",
  utm_list: "UTM List",
  search_by_member: "Search By Member",
  campaign: "Campaign",
  deposited: "Deposited",
  search_by_id: "Search By ID",
  get_bank_tac: "Get Bank OTP",
  bank_statement_daily: "Bank Statement (Daily)",
  transfer_type: "Transfer Type",
  audit_freebies_list: "Audit Freebies List",
  acknowledge: "Acknowledge",
  submit_acknowledgement: "Submit Acknowledgement",
  is_ack: "Is Ack",
  yes: "Yes",
  no: "No",
  audit_rescue_fund_list: "Audit Rescue Fund List",
  global_setting: "Global Setting",
  signup_ip: "Signup IP",
  last_login_ip: "Last Login IP",
  last_login_time: "Last Login Time",
  link: "Link",
  is_default: "Is Default",
  is_public: "Is Public",
  bank_group: "Bank Group",
  set_default: "Set Default",
  group_id: "Group ID",
  group_name: "Group Name",
  provider_maintenance: "Provider Maintenance",
  provider_code: "Provider Code",
  provider_name: "Provider Name",
  withdrawal_limit: "Withdrawal Limit",
  limit_id: "Limit ID",
  limit_name: "Limit Name",
  daily_amount: "Daily Amount",
  daily_frequency: "Daily Frequency",
  promotion_id: "Promotion ID",
  promotion_name: "Promotion Name",
  withhold_bonus: "Withhold Bonus",
  withhold_amount: "Withhold Amount",
  withhold_amt: "Withhold Amt",
  max_withdraw_amt: "Max Withdraw Amt",
  max_withdraw_amount: "Max Withdraw Amount",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  start_time: "Start Time",
  end_time: "End Time",
  day: "Day | Days",
  coupon_status: "Coupon Status",
  campaign_id: "Campaign ID",
  campaign_name: "Campaign Name",
  promotion_group: "Promotion Group",
  referee_list: "Referee List",
  account_verified: "Account Verified",
  verified_date: "Verified Date",
  ticket_list: "Ticket List",
  vip_id: "Vip ID",
  vip_name: "Vip Name",
  self_rebate_rate: "Self Rebate Rate(%)",
  downline_rebate_rate: "Downline Rebate Rate(%)",
  provider: "Provider",
  match_id: "Match ID",
  home_team: "Home Team",
  away_team: "Away Team",
  home_team_new: "Home Team New",
  away_team_new: "Away Team New",
  updated_by: "Updated By",
  updated_on: "Updated On",
  home_score: "Home Score",
  away_score: "Away Score",
  home_score_new: "Home Score New",
  away_score_new: "Away Score New",
  team: "Team",
  match_time: "Match Time",
  match_round: "Match Round",
  home_group: "Home Group",
  away_group: "Away Group",
  match: "Match",
  match_status: "Match Status",
  insert: "Insert",
  pin: "Pin",
  bet_list: "Bet List",
  result_list: "Result List",
  bet_id: "Bet ID",
  bet_home: "Bet Home",
  bet_away: "Bet Away",
  bet_on: "Bet On",
  min_deposit: "Min Deposit",
  min_withdrawal: "Min Withdrawal",
  raise_deposit_ticket: "Raise Deposit Ticket",
  method: "Method",
  one_time_depositor: "One Time Depositor",
  current_month_non_depositor: "Current Month Non Depositor",
  current_month_no_login: "Current Month No Login",
  ticket_date: "Ticket Date",
  ftd_amount: "FTD Amt",
  bonus_issue: "Bonus Issue",
  promotion_summary: "Promotion Summary",
  promotion_summary_detail: "Promotion Summary (Detail)",
  claim_frequency: "Claim Frequency",
  provider_list: "Provider List",
  platform_winlose: "Platform Winlose",
  adjustment_amount: "Adjustment Amount",
  referee_count: "Referee Count",
  category: 'Category',
  update_vip: "Update VIP",
  promotion_signup: "Promotion Signup",
  provider_bet_limit: "Provider Bet Limit",
  update_member_bet_limit: "Update Member Bet Limit",
  bet_limit: "Bet Limit",
  sports_game: "Sports/Game",
  league_name: "League Name",
  home_team_name: "Home Team Name",
  away_team_name: "Away Team Name",
  wl_status: "Winlose Status",
  available_bank_account: "Available Bank Account",
  group_bank_account: "Group Bank Account",
  edit_bank_group: "Edit Bank Group",
  edit_bank_account_group: "Edit Bank Account Group",
  redeposit: "Redeposit",
  upline: "Upline",
  downline: "Downline",
  available_promotion: "Available Promotion",
  group_promotion: "Group Promotion",
  edit_promotion_group: "Edit Promotion Group",
  edit_promotion_group_norm: "Manage Promotion In Group",
  balance_before: "Balance Before",
  balance_after: "Balance After",
  signup_count: "Signup Count",
  verified_count: "Verified Count",
  active_member: "Active Member",
  ftd_count: "FTD Count",
  daily_summary_company: "Daily Summary (Company)",
  daily_summary_operator: "Daily Summary (Operator)",
  daily_summary_member: "Daily Summary (Member)",
  daily_ledger_operator: "Daily Ledger (Operator)",
  bonus_list: "Bonus List",
  ltd_date: "LTD Date",
  adjustment_log: "Adjustment Log",
  get_inbox: "Get Inbox",
  is_claimed: "Is Claimed",
  mix_parlay: "Mix Parlay",
  event: "Event",
  result_changes_log: "Result Changes Log",
  view_detail: "View Detail",
  total_referee: "Total Referee",
  verified_signup: "Verified / Signup",
  ftd: "FTD | First Time Deposit",
  raw_msg: "Raw Message",
  unselect_all: "Unselect All",
  select_all: "Select All",
  edit_bet_limit: "Edit Bet Limit",
  provider_game_off: "Provider Game Off",
  provider_hot_game: "Provider Hot Game",
  game_id : "Game ID",
  game_list: "Game List",
  off_list: "Off List",
  provider_rtp: "Provider RTP",
  rtp: "RTP",
  signup_date: "Signup Date",
  free_credit: "Free Credit",
  downline_rebate: "Downline Rebate",
  game_rebate: "Game Rebate",
  rebate: "Rebate",
  ftd_date: "FTD Date",
  provider_winlose_company: "Provider Winlose (Company)",
  provider_winlose_operator: "Provider Winlose (Operator)",
  already_hit: "Already Hit",
  ongoing: "Ongoing",
  members_export: "Member (Export)",
  get_recent_deposit: "Get Recent Deposit",
  recent_deposit: "Recent Deposit",
  survey_list: "Survey List",
  modified_on: "Modified On",
  cms: "CMS",
  announcement_banner: "Announcement Banner",
  promotion_banner: "Promotion Banner",
  slide_banner: "Slide Banner",
  seo_page: "SEO Page",
  en_title: "Title (EN)",
  cn_title: "Title (CN)",
  local_title: "Title (LOCAL)",
  en_img: "Image (EN)",
  cn_img: "Image (CN)",
  local_img: "Image (LOCAL)",
  before_login: "Before Login",
  after_login: "After Login",
  en: "EN",
  move_up: "Move Up",
  move_down: "Move Down",
  banner_type: "Banner Type",
  default_order: "Default Order",
  item_order: "Item Order",
  title: "Title",
  banner_id: "Banner ID",
  order: "Order",
  body: "Body",
  en_image: "Image (EN)",
  local_image: "Image (LOCAL)",
  move: "Move",
  en_img_desktop: "Image Desktop (EN)",
  cn_img_desktop: "Image Desktop (CN)",
  local_img_desktop: "Image Desktop (LOCAL)",
  en_img_mobile: "Image Mobile (EN)",
  cn_img_mobile: "Image Mobile (CN)",
  local_img_mobile: "Image Mobile (LOCAL)",
  login_required: "Login Required",
  new_window_tab: "New Window / Tab",
  current_page: "Current Page",
  target: "Target",
  event_filter: "Event filter",
  alt: "Alt",
  href: "Href",
  image_desktop: "Desktop Image",
  image_mobile: "Mobile Image",
  en_alt: "Alt (EN)",
  local_alt: "Alt (LOCAL)",
  en_href: "Href (EN)",
  local_href: "Href (LOCAL)",
  en_image_desktop: "Desktop Image (EN)",
  active_period: "Active Period",
  en_item: "Item (EN)",
  local_item: "Item (LOCAL)",
  meta_title: "Meta Title",
  meta_keywords: "Meta Keywords",
  meta_url: "Meta URL",
  meta_canonical: "Meta Canonical",
  meta_author: "Meta Author",
  meta_publisher: "Meta Publisher",
  meta_lang: "Meta Lang",
  meta_desc: "Meta Desc",
  meta_image: "Meta Image",
  page: "Page",
  item: "Item",
  remove_desktop_image: "Remove Desktop Image",
  remove_mobile_image: "Remove Mobile Image",
  page_name: "Page Name",
  login_date: "Login Date",
  ftd_amount_min: "Min. FTD Amount",
  ftd_amount_max: "Max. FTD Amount",
  fl_provider_code: "First Launch Provider",
  fl_game_id: "First Launch Game ID",
  fl_game_name: "First Launch Game Name",
  top_deposit: "Top Deposit",
  top_withdrawal: "Top Withdrawal",
  top_promotion: "Top Promotion",
  outstanding_balance: "Outstanding Balance",
  last_update_time: "Last Update Time",
  trace: "Trace",
  trace_outstanding: "Trace Outstanding",
  outstanding: "Outstanding",
  clear_outstanding: "Clear Outstanding",
  meta_image_url: "Meta Image Url",
  member_bonus: "Member Bonus",
  crm_list: "CRM List",
  advance_search: "Advance Search",
  deposit_count_from: "Deposit Count From",
  deposit_count_to: "Deposit Count To",
  deposit_amount_from: "Deposit Amount From",
  deposit_amount_to: "Deposit Amount To",
  min_day_no_login: "Min. Day No Login",
  min_day_no_deposit: "Min. Day No Deposit",
  last_login: "Last Login",
  last_deposit: "Last Deposit",
  phone: "Phone",
  email: "Email",
  ip_whitelist: "IP Whitelist",
  ip: "IP",
  payment_option: "Payment Option",
  payment_mode: "Payment Mode",
  payment_desc: "Payment Desc",
  success: "SUCCESS",
  failed: "FAILED",
  bank_member_ewallet: "Bank Member (E-Wallet)",
  processing: "Processing",
  recipient_bank_id: "Recipient Bank ID",
  recipient_bank_acc_no: "Recipient Bank Acc No.",
  ticket_auto_withdrawal_log: "Ticket Log (Auto Withdrawal)",
  resubmit_ticket: "Resubmit ticket",
  ticket_export: "Ticket (Export)",
  export_deposit: "Export (Deposit)",
  export_deposit_all: "Export All (Deposit)",
  export_withdrawal: "Export (Withdrawal)",
  export_withdrawal_all: "Export All (Withdrawal)",
  export_member_all: "Export All (Member)",
  processed_rejected: "Processed (Rejected)",
  channel: "Channel",
  influencer: "Influencer",
  ticket_id: "Ticket ID",
  recommend: "Recommend",
  sequence: "Sequence",
  statement_info: "Statement Info",
  slots: "Slots",
  livecasino: "Livecasino",
  sportsbook: "Sportsbook",
  cockfight: "Cockfight",
  member_list: "Member List",
  operator: "Operator",
  game_balance: "Game Balance",
  claim_limit: "Claim Limit",
  max_withdraw_multiple: "Max Withdraw Multiple",
  payment_gateway: "Payment Gateway",
  min_limit: "Min Limit",
  max_limit: "Max Limit",
  total: "Total",
  rebate_summary: "Rebate Summary",
  rebate_summary_daily: "Rebate Summary Daily",
  rebate_member: "Rebate Member",
  self: "Self",
  system_balance: "System Balance",
  rejected_onload: "Rejected (Onload)",
  no_bonus: "No Bonus",
  audit_ticket: "Audit Ticket",
  review_ticket: "Review Ticket",
  edit_promotion_group_norm_seq: "Manage Promotion Sequence In Group",
  signup_bonus: "Signup Bonus",
  settlement_type: "Settlement Type",
  carry_over: "Carry Over",
  comm_sports: "Commission (Sports)",
  comm_slots: "Commission (Slots)",
  comm_livecasino: "Commission (Livecasino)",
  comm_cockfight: "Commission (Cockfight)",
  comm_others: "Commission (Others)",
  update_comm: "Update Commission",
  update_carry_over: "Update Carry Over",
  ewallet: "E-Wallet",
  withdrawal_list: "Withdrawal List",
  audit_withdrawal: "Audit Withdrawal",
  daily_withdrawal: "Daily Withdrawal",
  adjustment_log_affiliate: "Adjustment Log",
  daily_statement_affiliate: "Daily Statement (Affiliate)",
  earning: "Earning",
  pnl: "P&L",
  review_affiliate_ticket: "Review Affiliate Ticket",
  audit_affiliate_ticket: "Audit Affiliate Ticket",
  turnover_downline: "Turnover (Downline)",
  valid_turnover_downline: "Valid Turnover (Downline)",
  winlose_downline: "WinLose (Downline)",
  bet_count_downline: "Bet Count (Downline)",
  turnover_member: "Turnover (Member)",
  valid_turnover_member: "Valid Turnover (Member)",
  winlose_member: "WinLose (Member)",
  bet_count_member: "Bet Count (Member)",
  dashboard_affiliate: "Dashboard (Affiliate)",
  total_agent: "Total Agent",
  top_turnover: "Top Turnover",
  bonus_count: "Bonus Count",
  deposit_amount_downline: "Deposit Amount (Downline)",
  deposit_count_downline: "Deposit Count (Downline)",
  bonus_amount_downline: "Bonus Amount (Downline)",
  bonus_count_downline: "Bonus Count (Downline)",
  deposit_amount_member: "Deposit Amount (Member)",
  deposit_count_member: "Deposit Count (Member)",
  bonus_amount_member: "Bonus Amount (Member)",
  bonus_count_member: "Bonus Count (Member)",
  verified: "Verified",
  round_id: "Round ID",
  unfinish_round: "Unfinish Round",
  smartico_bonus_report: "Smartico Bonus Report",
  unclaimed_amount: "Unclaimed Amount",
  claimed_amount: "Claimed Amount",
  unclaimed_count: "Unclaimed Count",
  claimed_count: "Claimed Count",
  submit_time: "Created Date",
  deposit_time: "Modified Date",
  funds_list: "Ticket List",
  fund_transfer_provider: "Fund Transfer Provider",
  daifu_list_auto_withdrawal: "Ticket List (Auto Withdrawal)",
  btn_href: "Button Href",
  btn_text: "Button Text",
  recent_inbox_claim: "Recent Inbox Claim",
  raise_deposit_ticket_gateway: "Raise Deposit Ticket (Gateway)",
  gateway_acc: "Gateway Account",
  provider_winlose_member: "Provider Winlose (Member)",
  review_by: "Review By",
  daifu_list_auto_withdrawal_export: "Ticket Export (Auto Withdrawal)",
  retention: "Retenton",
  current_month_active_user: "Current Month Active User",
  current_month_active: "Current Month Active",
  first_month: "First Month",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "FMDeposit Amount",
  cohort: "Cohort",
  promotion_withdrawal_summary: "Promotion Withdrawal Summary",
  promotion_withdrawal_summary_detail: "Promotion Withdrawal Summary (Detail)",
  unique_player: "Unique Player",
  year: "Year | Years",
  audit_time_modified: "Modified Date",
  audit_time_created: "Created Date",
  approve_time: "Modified Date",
  unique_login_count: "Unique Login Count",
  unique_deposit_count: "Unique Deposit Count",
  unique_withdrawal_count: "Unique Withdrawal Count",
  second_deposit_count: "Second Deposit Count",
  unique_login: "Unique Login",
  unique_withdrawal: "Unique Withdrawal",
  second_deposit: "Second Deposit",
  deposit_withdrawal_different: "Deposit Withdrawal Different",
  ngr: "NGR",
  audit_list: "Audit List",
  rollback_count: "Rollback Count",
  rejected_ticket_id: "Rejected Ticket ID",
  rollback: "Rollback",
  recipient_bank_acc_holder: "Recipient Bank Acc Holder",
  reject_date: "Reject Date",
  processing_date: "Processing Date",
  manual_approve: "Approve (Manual)",
  pending_review_funds: "Pending & Review Ticket",
  table_id: "Table ID",
  member_label: "Member Label",
  label_name: "Label Name",
  label: "Label",
  available_label: "Available Label",
  iframe: "Iframe",
  iframe_url: "Iframe URL",
  exchange_rate: "Exchange Rate",
  rate: "Rate",
  rate_php: "Rate PHP",
  ticket_withdrawal_rollback: "Ticket Withdrawal Rollback",
  smartico_bonus_report_expired: "Smartico Bonus Report (Expired)",
  reward_type: "Reward Type",
  turnover_rebate: "Turnover Rebate",
  turnover_rebate_1: "VIP Tier",
  turnover_rebate_2: "Turnover Tier",
  vip_cycle_day: "VIP Cycle Day",
  is_addon: "Is Addon",
  no_reward: "No reward",
  cash: "Cash",
  cs: "Customer Service",
  social_platform: "Social Platform",
  edit_vip: "Edit VIP",
  edit_vip_provider: "Edit VIP Provider",
  turnover_tier: "Turnover Tier",
  rebate_rate: "Rebate Rate",
  edit_turnover_tier: "Edit Turnover Tier",
  delete_turnover_tier: "Delete Turnover Tier",
  vip_log: "VIP Log",
  member_full_record: "Member Full Record",
  before: "Before",
  after: "After",
  maintain: "Maintain",
  actual_rebate: "Actual Rebate",
  rounded_rebate: "Rounded Rebate",
  rebate_mode: "Rebate Mode",
  inbox_id: "Inbox ID",
  rebate_type: "Rebate Type",
  promotion_type: "Promotion Type",
  bonus_rate_1: "Rate 1(%)",
  bonus_rate_2: "Rate 2(%)",
  bonus_rate_3: "Rate 3(%)",
  bonus_rate_4: "Rate 4(%)",
  bonus_rate_5: "Rate 5(%)",
  bonus_rate_6: "Rate 6(%)",
  bonus_rate_7: "Rate 7(%)",
  bonus_rate_8: "Rate 8(%)",
  bonus_rate_9: "Rate 9(%)",
  bonus_rate_10: "Rate 10(%)",
  delete_all: "Delete All",
  rescue_fund: "Rescue Fund",
  up: "Up",
  down: "Down",
  rate_percent: "Rate %",
  cycle: "Cycle",
  actual_amount: "Actual Amount",
  rounded_amount: "Rounded Amount",
  rescue_id: "Rescue ID",
  rescue_name: "Rescue Name",
  min_lose: "Min Lose",
  max_payout: "Max Payout",
  payout_method: "Payout Method",
  target_group: "Target Group",
  member_vip_id: "Member VIP ID",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  edit_batch: "Edit Batch",
  current_level: "Current Level",
  next_level: "Next Level",
  bet_value: "Bet Value",
  line_bet: "Line Bet",
  total_round: "Total Round",
  audit_by: "Audit By",
  possible_next_level: "Possible Next Level",
  maintain_deposit: "Maintain Deposit",
  maintain_turnover: "Maintain Turnover",
  starting_deposit: "Starting Deposit",
  starting_turnover: "Starting Turnover",
  cycle_deposit: "Cycle Deposit",
  cycle_turnover: "Cycle Turnover",
  vip_list: "VIP List",
  up_maintain: "Up Maintain",
  down_lowest: "Down Lowest",
  manual: "Manual",
  daily_winlose_game: "Daily Winlose (Game)",
  actionaff: "Action (Affiliate)",
  onload: "onload",
  update_status: "Update Status",
  role_settings: "Role Settings",
  customer_services: "Customer Services",
  marketing: "Marketing",
  finance: "Finance",
  payment: "Payment",
  risk_management: "Risk Management",
  pt: "PT",
  wallet_history: "Wallet History",
  ticket_amount: "Ticket Amount",
  ignore_risk: "Ignore Risk",
  permitted_amount: "Permitted Amount",
  all_pending_ticket: "All Pending Tickets",
  rescue_fund_summary: "Rescue Fund Summary",
  rescue_fund_summary_daily: "Rescue Fund Summary Daily",
  rescue_fund_member: "Rescue Fund member",
  master: "Master",
  account_type: "Account Type",
  freeze: "Freeze",
  domain_member_setup: "Member site Domain Setup",
  domain: "Domain",
  domain_list: "Domain List",
  domain_application: "Domain Application",
  domain_status: "Domain Status",
  domain_group: "Domain Group",
  operator_id: "Operator ID",
  domain_type: "Domain Type",
  module: "Module",
  template: "Templates",
  custom: "Custom",
  default: "Default",
  payment_provider: "Payment Provider",
  payment: "Payment",
  deactivate: "Inactive",
  name_server: "Name Server",
  server_account: "Server Account",
  service_provider: "Service Provider",
  process: "Process",
  provider_operator: "Provider Operator",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "Global Settings",
  second_id: "Second ID",
  unverified: "Unverified",
  pt_affiliate: "Affiliate Platform Charges (%)",
  recipient_bank: "Recipient Bank",
  deposit_type: "Deposit Type",
  security_fund: "Security Fund",
  adjust_balance_op: "Adjust Operator Wallet",
  adjust_security_deposit_op: "Adjust Operator Security Fund",
  marquee: "Marquee",
  marquee_content: "Marquee content",
  edit_marquee: "Edit Marquee",
  domain_available: "Domain Available",
  daily_withdrawal_frequency: "Daily Withdrawal Frequency",
  maintenance: "Maintenance",
  max_withdrawal: "Max Withdrawal",
  min_balance: "Minimum Balance",
  affiliate_report: "Affiliate Reports",
  cash_balance: "Cash Balance",
  copy_success: "Copy successfully!",
  copy_failed: "Copy failed!",
  your_website: "Your Website",
  correction_promo: "Add Promotion",
  others: "Others",
  audit_log: "Audit Log",
  view: "View",
  price: "Price",
  package_level: "Package Level",
  bo_right: "BO Right",
  english: "English",
  simplified_chinese: "Chinese (CN)",
  traditional_chinese: "Chinese (TW)",
  philippine: "Philippine",
  thai: "Thai",
  vietnamese: "Vietnamese",
  indonesian: "Indonesian",
  myanmar: "Myanmar",
  japanese: "Japanese",
  korean: "Korean",
  package_type: "Package Type",
  full_back_office_access_right: "Full Back Office Access Right",
  read_only_back_office: "Readonly Back Office",
  language: "Language",
  lang_code: "Language Code",
  description: "Description",
  provider_type: "Provider Type",
  logo: "Logo",
  theme_provider: "Theme Provider",
  theme_content: "Theme Content",
  content_id: "Content ID",
  content_desc: "Content Desc",
  theme_content_position: "Theme Content Position",
  theme: "Theme",
  theme_code: "Theme Code",
  theme_name: "Theme Name",
  color: "Color",
  position: "Position",
  site_name: "Site Name",
  theme_color: "Theme Color",
  theme_purchased: "Theme Purchased",
  total_purchased: "Total Purchased",
  purchased_date: "Purchased Date",
  purchase: "Purchase",
  total_site: "Total Site",
  content_setup: "Content Setup",
  site_list: "Site List",
  site_id: "Site ID",
  draft_version: "Draft Version",
  prod_version: "Prod. Version",
  production_version: "Production Version",
  info: "Info",
  setting: "Setting",
  site_info: "Site Info",
  menu: "Menu",
  game_menu: "Game Menu",
  special_menu: "Special Menu",
  setting_menu: "Setting Menu",
  error: "Error",
  sync_all: "Sync All",
  theme_content_group: "Theme Content Group",
  content_group: "Content Group",
  content_group_desc: "Content Group Desc",
  parent_content_id: "Parent Content ID",
  bo_default_domain: "BO Default Domain",
  domain_id: "Domain ID",
  deactive: "Deactive",
  site_sync: "Site Sync",
  upload: "Upload",
  comingSoon: "Coming Soon",
  profile_setting: "Profile Setting",
  bank: "Bank",
  company: "Company",
  own: "OWN",
  operator_setting: "Operator Setting",
  external_id: "External ID",
  ticket: "Ticket",
  bank_owner: "Bank Owner",
  exchanged_currency: "Exchanged Currency",
  company_bank_owner: "Company Bank Owner",
  ticket_list_member: "Ticket List (Member)",
  game_name_exclude: "Game Name Exclude",
  tab: "Tab",
  about_us: "About Us",
  privacy_policy: "Privacy Policy",
  responsible_gaming: "Responsible Gaming",
  banking: "Banking",
  faqs: "FAQS",
  advertisement: "Advertisement",
  px_pixel_id: "PX Pixel ID",
  px_token: "PX Token",
  af_dev_key: "Af Dev Key",
  af_apps_id: "Af Apps ID",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "PP AID",
  gtm_id: "GTM ID",
  service_provider_url: "Service Provider URL",
  script_inject: "Script Inject",
  head_script: "Head Script",
  body_script: "Body Script",
  ads_id: "Ads ID",
  member_detail: "Member Detail",
  memberreport: "Member Report",
  member_log: "Member Log",
  general: "General",
  top_theme: "Top Theme",
  hot_game: "Hot Game",
  hot_list: "Hot List",
  new_game: "New Game",
  popular_game: "Popular Game",
  featured_game: "Featured Game",
  new_list: "New List",
  popular_list: "Popular List",
  featured_list: "Featured List",
  provider_new_game: "Provider New Game",
  provider_popular_game: "Provider Popular Game",
  provider_featured_game: "Provider Featured Game",
  website: "Website",
  site_customization: "Site Customization",
  export_all: "Export All",
  export_one: "Export (Current Page)",
  daily_ledger: "Daily Ledger",
  daily_ledger_member: "Daily Ledger (Member)",
  promotion_signup_unused: "Unused Signup Promotion",
  promotion_signup_ongoing: "Ongoing Signup Promotion",
  promotion_signup_winlose: "Signup Promotion Winlose",
  promotion_signup_winlose_operator: "Signup Promotion Winlose (Operator)",
  promotion_signup_winlose_member: "Signup Promotion Winlose (Member)",
  total_player_balance: "Total Player Balance",
  search_all: "Search All",
  mbsetting: "Settings",
  todays_highlights: "Today's Highlights",
  deposit_player: "Deposit Player",
  withdrawal_player: "Withdrawal Player",
  kill_rate: "Kill Rate",
  login_player: "Login Player",
  operation_management: "Operation",
  game_management: "Game",
  member_management: "Member",
  affiliate_management: "Affiliate",
  promotion_management: "Promotion",
  mbcampaign: "Campaign",
  promo_allday: "All Day",
  promo_daily: "Daily",
  promo_daily_first_deposit: "Daily First Deposit",
  promo_deposit_monthly: "Deposit Count Monthly",
  promo_deposit_signup: "Deposit Count Signup",
  promo_deposit_weekly: "Deposit Count Weekly",
  promo_newbie: "Newbie",
  promo_once: "Once",
  dd_review: "Review",
  game_provider_management: "Provider",
  exchanged_amount: "Exchanged Amount",
  operator_summary: "Operator Summary",
  business_id: "Business ID",
  game_name_exclude_log: "Game Name Exclude Log",
  cn: "CN",
  local: "LOCAL",
  taken: "Taken",
  receiver_bank: "Receiver Bank",
  receiver_bank_acc_no: "Receiver Bank Acc No.",
  receiver_bank_acc_holder: "Receiver Bank Acc Holder",
  add_balance: "Add Balance",
  deduct_balance: "Deduct Balance",
  sync_site_content: "Sync Site Content",
  payment_setting: "Payment Setting",
  payment_own: "OWN",
  payment_global: "GLOBAL",
  livechat: "LiveChat",
  chat_id: "LiveChat License Key",
  chat_provider: "LiveChat Provider",
  auto_cycle: "CYCLE",
  auto_all: "ALL",
  completed_amount: "Completed Amount",
  website_launched: "Website Launched",
  total_operators: "Total Operators",
  today_active: "Today Active",
  new_player_verified_signup: "New player Verified/Signup",
  total_players: "Total Players",
  depo_withdrawal_diff: "DEPO-WITH Difference",
  claim_count: "Claim Count",
  ggr: "GGR",
  member_balance: "Member Balance",
  players: "Players",
  provider_pt: "Provider PT",
  base: "Base",
  topup_id: "Topup ID",
  credential: "Credential",
  credential_1: "Credential 1",
  credential_2: "Credential 2",
  credential_3: "Credential 3",
  credential_4: "Credential 4",
  credential_5: "Credential 5",
  credential_6: "Credential 6",
  credential_7: "Credential 7",
  credential_8: "Credential 8",
  credential_9: "Credential 9",
  credential_10: "Credential 10",
  limit: "Limit",
  create: "Create",
  hint: "Hint",
  quickSetup: "Quick Setup",
  next: "Next",
  setUpTheme: "SetUp Theme",
  checkOut: "Check Out",
  standardPackage: "Standard Package",
  siteName: "Site Name",
  information: "Information",
  useThisTemplate: "Use This Template",
  summary: "Summary",
  createOperatorAccount: "Create Operator Account",
  operatorId: "Operator ID",
  operatorPwd: "Operator Passsword",
  new_website: "New Website",
  operator_information: "Operator Information",
  bo_link: "BO Link",
  daily_summary_sms: "Daily Summary SMS",
  daily_summary_sms_operator: "Daily Summary SMS Operator",
  daily_summary_sms_operator_detail: "Daily Summary SMS Operator Detail",
  sms_count: "SMS Count",
  provider_winlose_operator_pt: "Provider Winlose (Operator PT)",
  pt_on: "PT On",
  share_operator: "Share Operator",
  share_company: "Share Company",
  token_log: "Token Log",
  template_code: "Template Code",
  template_name: "Template Name",
  mini_game: "Mini Game",
  max_game_reward: "Max. Game Reward",
  max_chance_per_day: "Max. Chance per Day",
  is_recurring_chance: "Recurring",
  token_request: "Token",
  enabled: "Enabled",
  disabled: "Disabled",
  unlimited: "Unlimited",
  max_chance_unlimited: "Max. Chance per Day Unlimited",
  mini_game_template: "Mini Game Template",
  reward_code: "Reward Code",
  reward_name: "Reward Name",
  reward_description: "Reward Description",
  reward_probability: "Reward Probability",
  total_game: "Total Game",
  total_played_mini_game: "Total Played Mini Game",
  total_played_mini_game_detail: "Total Played Mini Game Detail",
  total_played_mini_game_detail_operator: "Total Played Mini Game Detail (Operator)",
  daily_pnl_operator: "Daily P&L (Operator)",
  token: "Token",
  token_1: "Token 1",
  token_2: "Token 2",
  token_3: "Token 3",
  token_4: "Token 4",
  token_5: "Token 5",
  token_6: "Token 6",
  token_7: "Token 7",
  cash_1: "Cash 1",
  cash_2: "Cash 2",
  cash_3: "Cash 3",
  cash_4: "Cash 4",
  cash_5: "Cash 5",
  cash_6: "Cash 6",
  cash_7: "Cash 7",
  daily_login: "Daily Check-in (Daily Login)",
  daily_login_update: "Daily Check-in (Daily Login) Update",
  game_result_reward: "Game Result (Reward)",
  current_streak: "Current Streak",
  login_streak: "Login Streak",
  total_token: "Total Token",
  total_mini_game_token_used: "Total Mini Game Token Used",
  total_mini_game_token_used_detail: "Total Mini Game Token Used Detail",
  total_mini_game_token_used_detail_operator: "Total Mini Game Token Used Detail (Operator)",
  total_reward: "Total Reward",
  total_mini_game_reward: "Total Mini Game Reward",
  total_mini_game_reward_detail: "Total Mini Game Reward Detail",
  total_mini_game_reward_detail_operator: "Total Mini Game Reward Detail (Operator)",
  token_balance: "Token Balance",
  free_game_token: "Free Game Token",
  bo_url: "Backoffice Url",
  copied: "Copied",
  callback: "Callback",
  api: "API",
  prefix: "Prefix",
  delimiter: "Delimiter",
  url_callback_deposit: "Deposit Callback URL",
  url_callback_withdrawal: "Withdrawal Callback URL",
  url_callback_affiliate: "Affiliate Callback URL",
  url_api_deposit: "Deposit Callback URL (API)",
  url_api_withdrawal: "Withdrawal Callback URL (API)",
  url_api_balance: "Balance Callback URL (API)",
  prefix_deposit: "Deposit Prefix",
  prefix_withdrawal: "Withdrawal Prefix",
  prefix_affiliate: "Affiliate Prefix",
  prefix_delimiter: "Delimiter Prefix",
  merchant: "Merchant",
  app_id: "App ID",
  secret_key: "Secret Key",
  deposit_secret_key: "Deposit Secret Key",
  withdrawal_secret_key: "Withdrawal Secret Key",
  partners: "Partners",
  partner_name: "Partner Name",
  win: "Win",
  manifest: "Manifest",
  crop: "Crop",
  cropImage: "Crop Image",
  api_url: "API URL",
  start_date_time: "Start Date Time",
  end_date_time: "End Date Time",
  authentication_key: "Authentication Key",
  one_week: "1 Week",
  two_week: "2 Weeks",
  one_month: "1 Month",
  two_month: "2 Months",
  six_month: "6 Months",
  edit_promotion_end_date: "Edit Promotion End Date",
  android_app_link: "Android App Link",
  add_android_app_link: "Add Android App Link",
  operator_details: "Operator Details",
  bsb: "BSB",
  payid: "Pay ID",
  cuit: "CUIT",
  merchant_key: "Merchant Key",
  aes_key: "AES Key",
  paycode: "PayCode",
  api_key: "API Key",
  referral: "Referral Reward",
  minimum_deposit: "Minimum Deposit",
  minimum_withdrawal: "Minimum Withdrawal",
  maximum_withdrawal: "Maximum Withdrawal",
  cpi: "CPI",
  cpi_enrol: "CPI Enrol",
  interested: "Interested",
  non_pickup: "Non-Pickup",
  invalid: "Invalid",
  cpi_member_list: "CPI Member List",
  leaderboard: "Leaderboard",
  capacity: "Capacity",
  reward_count: "Reward Count",
  is_settled: "Is Settled",
  settlement_date: "Settlement Date",
  prize: "Prize",
  count: "Count",
  multiplier: "Multiplier",
  ranking: "Ranking",
  leaderboard_ranking: "Leaderboard Ranking",
  joined_date: "Joined Date",
  ready: "Ready",
  busy: "Busy",
  phone_list: "Phone List",
  single: "Single",
  batch: "Batch",
  cpi_operator_phone_list: "CPI Operator Phone List",
  selected: "Selected",
  call: "Call",
  private_key: "Private Key",
  public_key: "Public Key",
  multi_call: "Multi Call",
  add_custom: "Add Custom",
  custom_list: "Custom List",
  assignee: "Assignee",
  urgency: "Urgency",
  urgency_1: "Low",
  urgency_2: "Moderate",
  urgency_3: "High",
  edit_custom: "Edit Custom",
  cpi_custom_list: "CPI Custom List",
  free_coin_signup: "Free Point (Signup)",
  free_coin_daily: "Free Point (Daily)",
  free_coin_min_withdrawal: "Minimum Withdrawal (Free Point)",
  free_coin_per_unit: "Free Point Exchange Rate (Point = {currency} 1)",
  adjust_free_balance: "Adjust Free Balance",
  adjust_free_balance_log: "Free Balance Log",
  signup: "Signup",
  adjust: "Adjust",
  ai_assistant: "AI Assistant",
  en_name: "Name (EN)",
  cn_name: "Name (CN)",
  local_name: "Name (LOCAL)",
  img_small: "Image (Small)",
  img_large: "Image (Large)",
  small_image: "Small Image",
  large_image: "Large Image",
  forgot_password: "Forgot Password",
  update_password: "Update Password",
  contact: "Contact",
  keyss: "Key",
  iv: "IV",
  callback_public_key: "Callback Public Key",
  free_game: "Free Game",
  version_no: "Version No.",
  client_id: "Client ID",
  symmetric_key: "Symmetric Key",
  deposit_token : "Deposit Token",
  withdrawal_token : "Withdrawal Token",
  tac_bank: "OTP (Bank)",
  tac_login: "OTP (Login)",
  tac_signup: "OTP (Signup)",
  tac_signup_aff: "OTP (Affiliate Signup)",
  merchant_name: "Merchant Name",
  tele_status: "Tele Status",
  follow_up: "Follow-Up",
  call_type: "Call Type",
  on_call_list: "On Call List",
  inbox_valid_day: "Inbox Valid Day",
  manual_deposit: "Manual Deposit",
  withdrawal_result: "Withdrawal Result",
  widget_id: "Widget ID",
  property_id: "Property ID",
  referee: "Referee Reward",
  game_result_free_slots: "Game Result (Free Slots)",
  crypto_address: "Crypto Address",
  crypto_network: "Crypto Network",
  crypto: "CRYPTO",
  exchange_currency: "Exchange Currency",
  base_rate: "Base Rate",
  white_label: "White Label",
  aggregator: "Aggregator",
  deposit_rate: "Deposit Rate",
  withdrawal_rate: "Withdrawal Rate",
  pending_bet_list_wbet: "Pending Bet List (WBET)",
  bet_amount: "Bet Amount",
  actual_bet_amount: "Actual Bet Amount",
  pending_bet_list_others: "Pending Bet List (Other Sportsbook)",
  dob: "Date of Birth",
  mail_address: "Mail Address",
  crypto_withdrawal: "Crypto Withdrawal",
  institute_bank_code: "Institute Bank Code",
  pending_bet_list_9w: "Pending Bet List (9W)",
  linkage: "Linkage",
  linkage_op: "Linkage Operator",
  member_linkage: "Member Linkage",
  risk_weight: "Risk Weight",
  full_linkage: "Full Linkage",
  total_risk_score: "Total Risk Score",
  linkage_value: "Linkage Value",
  source_occurrence_count: "Source Occurrence Count",
  source_last_seen_at: "Source Last Seen At",
  target_occurrence_count: "Target Occurrence Count",
  target_last_seen_at: "Target Last Seen At",
  member_linkage_detail: "Member Linkage Detail",
  merchant_uid: "Merchant UID",
  merchant_no: "Merchant Number",
  slot_view: "Slot View",
  settlement_list_affiliate: "Settlement List (Affiliate)",
  source: "Source",
  earning_breakdown: "Earning Breakdown",
  deposit_bonus: "Deposit Bonus",
  winlose_turnover: "WL/TO",
  cost: "Cost",
  promotion_voucher: "Promotion Voucher",
  voucher_id: "Voucher ID",
  voucher_cash: "Voucher Cash",
  ticketvoucher: "Ticket Voucher",
  ticket_voucher_list_member: "Ticket Voucher List (Member)",
  ticket_voucher_list: "Ticket Voucher List",
  pending_review_funds_voucher: "Pending & Review Ticket Voucher",
  all_pending_ticket_voucher: "All Pending Tickets Voucher",
  ticket_voucher_detail: "Ticket Voucher Detail",
  raise_deposit_ticket_voucher: "Raise Deposit Ticket Voucher",
  raise_deposit_ticket_voucher_gateway: "Raise Deposit Ticket Voucher Gateway",
  sos: "SOS Topup",
  sos_accumulate_deposit: "SOS Topup (Accumulate Deposit)",
  greeting: "Greeting",
  message: "Message",
  get_voucher: "Get Voucher",
  get_message: "Get Message",
  voucher: "Voucher",
  code: "Code",
  redeemed_by: "Redeemed By",
  redeemed_by_operator: "Redeemed By (Operator)",
  redeemed_at: "Redeemed At",
  created_at: "Created At",
  redeemed: "Redeemed",
  member_sos_click_log: "Member SOS Click Log",
  member_wallet_voucher_log: "Member Wallet Voucher Log",
  member_voucher_redeemed_log: "Member Voucher Redeemed Log",
  action_by_operator: "Action By (Operator)",
  redeem_cash: "Redeem Cash",
  generate_voucher: "Generate Voucher",
  url_api_freecredit: "Free Credit Callback URL",
  prefix_freecredit: "Free Credit Prefix",
  free_credit_member: "Free Credit Member",
  free_credit_provider: "Free Credit Provider",
  ticket_detail_fcp: "Ticket Detail Free Credit Provider",
  ticket_list_processed: "Ticket List (Processed)",
  non_slot_view: "Non Slot View",
  banner: "Banner",
  mission: "Mission",
  trigger: "Trigger",
  event_type: "Event Type",
  action_type: "Action Type",
  msg_greeting: "Greeting (Message)",
  msg_title: "Title (Message)",
  msg_body: "Body (Message)",
  send_message: "Send Message",
  promo_type: "Promo Type",
  repeatable: "Repeatable",
  rules: "Rules",
  clear_outstanding_log: "Clear Outstanding Log",
  free_credit_withdrawal_amount: "Free Credit Withdrawal Amount",
  fc_withdrawal_amount: "FC Withdrawal Amount",
  frozen: "Frozen",
  transferred: "Transferred",
  voucher_balance: 'Voucher Balance',
  adjust_voucher_balance: "Adjust Voucher Balance",
  free_game_provider: "Free Game Provider",
  check_free_spin: "Check Free Spin",
  freespin_log: "Freespin Log",
  current_round: "Current Round",
  lines: "Lines",
  expiry_interval_days: "Expiry Interval (Days)",
  assign: "Assign",
  game_code: "Game Code",
  clear_free_credit: "Clear Free Credit",
  deposit_tier: "Deposit Tier",
  point: "Point",
  top: "Top",
  bottom: "Bottom",
  leaderboard_banner: "Leaderboard Banner",
  referral_banner: "Referral Banner",
  tp_site: "Traffic Pool URL",
  current_icon: "Current Icon",
  new_icon: "New Icon",
  voucher_redeemed: "Voucher Redeemed",
  on_site: "On Site",
  exclude_own: "Exclude Own",
  voucher_redeemed_detail: "Voucher Redeemed Detail",
  gamification: "Gamification",
  reward_rain: "Reward Rain",
  total_claimed_amount: "Total Claimed Amount",
  min_amount: "Minimum Amount",
  max_amount: "Maximum Amount",
  reward_rain_session: "Reward Rain Session",
  reward_rain_session_claim: "Reward Rain Session Claim",
  reward_amount: "Reward Amount",
  cta: "CTA",
  api_email: "API Email",
  api_password: "API Password",
  url_callback_voucher: "Voucher Callback URL",
  prefix_voucher: "Voucher Prefix",
  slide_show: "Slide Show",
  ewallet_withdrawal: "E-Wallet Withdrawal",
  news: "News",
  slug: "Slug",
  preview_body: "Preview Body",
  full_body: "Full Body",
  normal: "Normal",
  free_balance: "Free Balance",
  schema: "Schema",

  tt_pixel_id: "TT Pixel ID",
  tt_token: "TT Token",

  free_spin_bulk_issue : "Free Spin (Bulk Issue)",
}